import { render, staticRenderFns } from "./global_alerts.vue.js?vue&type=template&id=2c45b7b0!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./global_alerts.vue?vue&type=template&id=2c45b7b0"
import script from "./global_alerts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./global_alerts.vue?vue&type=script&lang=js"
export * from "./global_alerts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./global_alerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports